import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('@shared/shared.routes').then(m => m.SHARED_ROUTES),
  },
  {
    path: 'main',
    canActivate: [AuthGuard],
    loadComponent: () => import('./layout/components/main/main.component').then(c => c.MainComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.routes').then(m => m.PROFILE_ROUTES),
      },
      {
        path: 'deposit',
        loadChildren: () => import('./features/deposit/deposit.routes').then(m => m.DEPOSIT_ROUTES),
      },
      {
        path: 'withdraw',
        loadChildren: () => import('./features/withdraw/withdraw.routes').then(m => m.WITHDRAW_ROUTES),
      },
    ],
  },
];
